var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuredPersonalData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 32C32.2435 32 36.3131 30.3143 39.3137 27.3137C42.3143 24.3131 44 20.2435 44 16C44 11.7565 42.3143 7.68687 39.3137 4.68629C36.3131 1.68571 32.2435 0 28 0C23.7565 0 19.6869 1.68571 16.6863 4.68629C13.6857 7.68687 12 11.7565 12 16C12 20.2435 13.6857 24.3131 16.6863 27.3137C19.6869 30.3143 23.7565 32 28 32ZM22.2875 38C9.975 38 0 47.975 0 60.2875C0 62.3375 1.6625 64 3.7125 64H49.0625C48.3875 62.825 47.9875 61.4625 47.9875 60V44C47.9875 43.7375 48 43.475 48.025 43.2125C44.15 39.9625 39.15 38 33.7 38H22.275H22.2875ZM66 30C68.2125 30 70 31.7875 70 34V40H62V34C62 31.7875 63.7875 30 66 30ZM56 34V40C53.7875 40 52 41.7875 52 44V60C52 62.2125 53.7875 64 56 64H76C78.2125 64 80 62.2125 80 60V44C80 41.7875 78.2125 40 76 40V34C76 28.475 71.525 24 66 24C60.475 24 56 28.475 56 34Z",
    fill: "#54FF99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredPersonalData);
export default __webpack_public_path__ + "static/media/secured-personal-data.19a86d5ace5b64708ab9aaeb7c11eb02.svg";
export { ForwardRef as ReactComponent };